export default __webpack_public_path__ + "static/media/AdjuntarOscuro.523e80aa.svg";